const UPDATED = "July 12, 2026";

function Section({ title, children }) {
  return (
    <section className="mt-8">
      <h2 className="font-serif text-xl text-brand-forest">{title}</h2>
      <div className="mt-3 space-y-3 text-sm text-brand-ink/75 leading-relaxed">{children}</div>
    </section>
  );
}

export default function Terms() {
  return (
    <main data-testid="terms-page" className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-16">
      <span className="label-eyebrow">Legal</span>
      <h1 className="mt-3 font-serif text-4xl md:text-5xl text-brand-forest leading-tight">
        Terms &amp; Conditions
      </h1>
      <p className="mt-3 text-sm text-brand-muted">Last updated: {UPDATED}</p>

      <div className="mt-6 bg-white border border-brand-line rounded-md p-6 md:p-8">
        <p className="text-sm text-brand-ink/75 leading-relaxed">
          These Terms &amp; Conditions govern your use of the Build A Bank IBC Savings
          Calculator platform (the "Service"), operated by High Vibe Pinnacle Pictures. By
          using the Service you agree to these terms.
        </p>

        <Section title="1. The Service">
          <p>
            The Service provides financial illustration tools for advisors trained in the
            Infinite Banking Concept (IBC), including savings projections, scenario
            management, lead capture, and branded reporting, targeted at Ontario business
            owners.
          </p>
        </Section>

        <Section title="2. Not financial, tax, or legal advice">
          <p>
            All calculator outputs, projections, and reports are <strong>hypothetical
            illustrations</strong> based on the inputs and assumptions provided. They are not
            a guarantee of future performance and do not constitute financial, tax,
            accounting, insurance, or legal advice. Always consult a licensed professional
            before making financial decisions. Policy dividend rates are not guaranteed and
            are set by the issuing insurer.
          </p>
        </Section>

        <Section title="3. Advisor accounts">
          <p>
            Advisor access requires signing in with Google. You are responsible for the
            accuracy of the information you present to clients and for complying with all
            licensing and regulatory obligations that apply to you (including LLQP and
            provincial insurance regulations). Each advisor's workspace is private; attempting
            to access another user's data is prohibited.
          </p>
        </Section>

        <Section title="4. Fees and billing">
          <p>
            Platform subscriptions and per-qualified-lead fees are described on the pricing
            page available inside your account. Qualified leads captured through your personal
            referral link are counted toward your monthly billing cycle at your account's
            per-lead rate. Fees are in Canadian dollars and are non-refundable except as
            required by law. Payments are processed by Stripe.
          </p>
        </Section>

        <Section title="5. Acceptable use">
          <p>
            You agree not to misuse the Service, including submitting false lead information,
            scraping data, reverse engineering, or using the Service to send unsolicited
            communications in violation of CASL (Canada's Anti-Spam Legislation).
          </p>
        </Section>

        <Section title="6. Intellectual property">
          <p>
            The Service, including its calculators, design, and content, is owned by High Vibe
            Pinnacle Pictures. You retain ownership of the data and branding you upload.
          </p>
        </Section>

        <Section title="7. Limitation of liability">
          <p>
            To the maximum extent permitted by law, the Service is provided "as is" and we are
            not liable for indirect, incidental, or consequential damages, or for decisions
            made in reliance on calculator outputs. Our total liability is limited to the fees
            you paid in the three months preceding the claim.
          </p>
        </Section>

        <Section title="8. Termination">
          <p>
            We may suspend or terminate accounts that violate these terms. You may stop using
            the Service at any time; billing obligations accrued before termination remain
            payable.
          </p>
        </Section>

        <Section title="9. Governing law">
          <p>
            These terms are governed by the laws of the Province of Ontario and the federal
            laws of Canada applicable therein.
          </p>
        </Section>

        <Section title="10. Contact">
          <p>
            Questions about these terms may be directed to High Vibe Pinnacle Pictures through
            the contact details published on this website.
          </p>
        </Section>
      </div>
    </main>
  );
}
